module.exports = __webpack_public_path__ + "static/media/1027611.d091b275.jpg";